
export const apiSublevels = [
  "functionality",
  "request",
  "response",
  "usecases",
  "errorcodes",
];
